import { useEffect } from 'react';

/**
 * Keeps fixed bottom chrome (FAB) above iOS Safari’s collapsing toolbar by
 * exposing the visual viewport inset as --viewport-fab-offset on :root.
 */
export function useVisualViewportFabOffset(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    const root = document.documentElement;
    const vv = window.visualViewport;

    const apply = () => {
      if (!vv) {
        root.style.setProperty('--viewport-fab-offset', '0px');
        return;
      }
      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty('--viewport-fab-offset', `${Math.round(inset)}px`);
    };

    apply();
    vv?.addEventListener('resize', apply);
    vv?.addEventListener('scroll', apply);
    window.addEventListener('orientationchange', apply);
    window.addEventListener('resize', apply);

    return () => {
      vv?.removeEventListener('resize', apply);
      vv?.removeEventListener('scroll', apply);
      window.removeEventListener('orientationchange', apply);
      window.removeEventListener('resize', apply);
      root.style.removeProperty('--viewport-fab-offset');
    };
  }, [enabled]);
}
